/**
 * GlobalQuickCapture — globální FAB + listener pro Quick Capture modal.
 *
 * Renderuje se v App.js nad celou aplikací, takže funguje v:
 *   - legacy admin (/admin/*)
 *   - admin2 desktop (/admin2/*)
 *   - mobile admin (/m/*)
 *
 * Otevření:
 *   - klik na fialový FAB vpravo dole
 *   - klávesa "c" (mimo input/textarea)
 *   - window.dispatchEvent(new CustomEvent("quick-capture", { detail: { type: "lead" } }))
 *
 * Skrývá se na public stránkách (Landing, /poptavka, /thank-you).
 */
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import QuickCaptureModal from "./QuickCaptureModal";

const HIDE_ON_PATHS = ["/login", "/poptavka", "/thank-you", "/forgot-password", "/reset-password"];

export default function GlobalQuickCapture() {
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const [type, setType] = useState("inquiry");

  // Show only on authenticated routes (admin, admin2, mobile)
  const shouldShow =
    !HIDE_ON_PATHS.some((p) => location.pathname.startsWith(p)) &&
    location.pathname !== "/" &&
    (location.pathname.startsWith("/admin") || location.pathname.startsWith("/m"));

  useEffect(() => {
    const handler = (e) => {
      const t = e?.detail?.type;
      if (t && ["inquiry", "lead", "idea", "note"].includes(t)) setType(t);
      setOpen(true);
    };
    window.addEventListener("quick-capture", handler);

    const keyHandler = (e) => {
      if (!shouldShow) return;
      // Ignore when typing in inputs
      const tag = e.target?.tagName?.toLowerCase();
      const isEditable = ["input", "textarea", "select"].includes(tag) || e.target?.isContentEditable;
      if (isEditable) return;
      if (e.key === "c" && !e.ctrlKey && !e.metaKey && !e.altKey) {
        e.preventDefault();
        setOpen(true);
      }
    };
    window.addEventListener("keydown", keyHandler);

    return () => {
      window.removeEventListener("quick-capture", handler);
      window.removeEventListener("keydown", keyHandler);
    };
  }, [shouldShow]);

  if (!shouldShow) return null;

  // iter409d — FAB visible button removed (user request: "Rychlý záznam překáží").
  // The modal can still be opened via:
  //   - keyboard shortcut "c"
  //   - window.dispatchEvent(new CustomEvent("quick-capture", { detail: { type: "lead" }}))
  return (
    <>
      {open && (
        <QuickCaptureModal
          defaultType={type}
          onClose={() => setOpen(false)}
          onSaved={() => setOpen(false)}
        />
      )}
    </>
  );
}
